import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const ResetPasswordPageUser = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setError("Invalid or missing token.");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      let endpoint = "";

      // Try resetting password for regular users first
      try {
        const userResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/user/reset-password/${token}`,
          { newPassword }
        );

        if (userResponse.status === 200) {
          endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/user/reset-password/${token}`;
        }
      } catch (userError) {
        console.warn("User token not found, checking department user...");
      }

      // If no regular user, try department user
      if (!endpoint) {
        endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/deptUser/reset-password/${token}`;
      }

      // Send request to the correct endpoint
      const response = await axios.post(endpoint, { newPassword });

      if (response.status === 200) {
        setSuccessMessage("Password reset successful! Redirecting...");
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Center vertically
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
          width: "100%", // Ensures proper responsiveness
          maxWidth: 400, // Controls max width of the form
        }}
      >
        <Typography variant="h5" align="center">
          Reset Password
        </Typography>

        {error && <Alert severity="error">{error}</Alert>}
        {successMessage && <Alert severity="success">{successMessage}</Alert>}

        <TextField
          label="New Password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          fullWidth
          required
        />
        <TextField
          label="Confirm Password"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          fullWidth
          required
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          fullWidth
          disabled={loading}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </Button>
      </Box>
    </Container>
  );
};

export default ResetPasswordPageUser;
